import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0461dfa1&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/app/components/link/Link.vue').default,ListHeader: require('/app/components/list/ListHeader.vue').default,ListSideAlbum: require('/app/components/list/ListSideAlbum.vue').default,ListArticle: require('/app/components/list/ListArticle.vue').default,ListNews: require('/app/components/list/ListNews.vue').default})
